import * as React from 'react';
import { Form } from 'ssc-ui-react';

import { $gt } from '@/common/appCtx';

import { OriginGroupItem } from '../../defined';
import styles from './index.module.less';
import Throughput from './throughput';
import TopOperators from './top-operators';

export interface GroupPerformanceProps {
  curGroupItem: OriginGroupItem;
  loading: boolean;
}

const GroupPerformance: React.FC<GroupPerformanceProps> = (props) => {
  const throughputData = React.useMemo(() => {
    return {
      workstation_group_id: props.curGroupItem.workstation_group_id,
      order: props.curGroupItem.total_throughput,
      workstations: props.curGroupItem.total_active_workstation_count,
      operators: props.curGroupItem.total_active_ops_count,
      scanList: props.curGroupItem.interactive_type_throughput_list,
      nonScanList: props.curGroupItem.non_interactive_type_throughput_list
    };
  }, [props.curGroupItem]);
  return (
    <div className={styles.groupPerformance}>
      <Form.Legend
        level={1}
      >
        {$gt('Group Performance')}
      </Form.Legend>
      <div className={styles.content}>
        <Throughput
          loading={props.loading}
          {...throughputData}
        />
        <TopOperators
          workstationGroupId={props.curGroupItem.workstation_group_id}
          workstationGroupName={props.curGroupItem.workstation_group}
        />
      </div>
    </div>
  );
};

export default GroupPerformance;
